<template>
<svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
    <path d="M14 2v12H2V2h12m0-2H2C.9 0 0 .9 0 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2Z"/>
    <path d="M12 7H9V4H7v3H4v2h3v3h2V9h3V7z"/>
</svg>
</template>
      